import { TaskStatus } from "tm-shared/types";

type WithStatusAndComment = {
    status: TaskStatus;
    comment?: string;
};

export const isSubtaskCompleted = (p?: WithStatusAndComment): boolean => {
    if (!p) return false;

    return (
        p.status === TaskStatus.Completed ||
        (p.status === TaskStatus.Rejected && Boolean(p.comment))
    );
};
